import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-create-edit-empleado',
  templateUrl: './create-edit-empleado.component.html',
  styleUrls: ['./create-edit-empleado.component.scss'],
})
export class CreateEditEmpleadoComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Crear empleado';

  constructor(
    public perfilSvc: ProfileService,
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditEmpleadoComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt = 'Editar empleado';
    }
  }

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      nombre: new UntypedFormControl('', Validators.required),
      tipoDocumento: new UntypedFormControl('', Validators.required),
      documento: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(15),
      ]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      celular: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[0-9]*'),
      ]),
      perfilId: new UntypedFormControl('', Validators.required),
      estado: new UntypedFormControl(''),
    });
    this.registerForm.get('estado')?.setValue(1);

    this.documentos = [
      { value: 1, nombre: 'CC' },
      { value: 2, nombre: 'Pasaporte' },
      { value: 3, nombre: 'NIT' },
      { value: 4, nombre: 'C. Extranjeria' },
    ];

    this.perfilSvc.getPerfilesEmpleados().subscribe((x) => {
      this.perfiles = x;

      if (this.dataInput != null) {
        this.registerForm.get('id')?.setValue(this.dataInput.id);
        this.registerForm.get('nombre')?.setValue(this.dataInput.nombre);
        this.registerForm
          .get('tipoDocumento')
          ?.setValue(this.dataInput.tipoDocumento);
        this.registerForm.get('documento')?.setValue(this.dataInput.documento);
        this.registerForm.get('email')?.setValue(this.dataInput.email);
        this.registerForm.get('celular')?.setValue(this.dataInput.celular);
        this.registerForm.get('perfilId')?.setValue(this.dataInput.perfilId);
        this.registerForm.get('estado')?.setValue(1);
      }
    });
  
    this.getFormValidationErrors();
  }

  getFormValidationErrors() {
    Object.keys(this.registerForm.controls).forEach(key => {
      const controlErrors: any = this.registerForm.get(key)?.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  getErrorMessageEmail() {
    if (this.registerForm.get('email')?.hasError('required')) {
      return 'El email es requerido';
    }
    if (this.registerForm.get('email')?.hasError('email')) {
      return 'No es un email valido';
    }
    return '';
  }

  guardar() {
    console.log('guardar usuario');
    console.log(this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar
      this.usrSvc.editarEmpleado(this.registerForm.value).subscribe((res) => {
        console.log('resultado EditarUsuario: ', res);
        if (res) {
          this.alertify.success('Empleado actualizado correctamente');
          this.dialogRef.close();
        } else {
          this.alertify.error('El empleado no se ha podido actualizar');
        }
      });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
    //    this.registerForm.get('estado')?.setValue(0);
      this.usrSvc.createEmpleado(this.registerForm.value).subscribe((res) => {
        console.log('resultado crear: ', res);
        if (res) {
          this.alertify.success('Empleado creado correctamente');
          this.dialogRef.close();
        } else {
          this.alertify.error(
            'El empleado ya existe, valide la información e intentelo de nuevo'
          );
        }
      });
    }
  }
}
